module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Inventory",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "ProduceName or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getInventory.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getInventory
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportNurseInventory', 'Inventory.xls')
      }
    }
  }, [_vm._v("Export")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.goToMixedPackageClaim
    }
  }, [_vm._v("Mixed Package")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.products,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productNo) + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "ProductName"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productName) + " " + _vm._s(scope.row.createDate ? "(" + scope.row.createDate + ")" : "") + "\n\t\t\t\t\t\t\t"), _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.upc))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "left",
      "label": "Left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showReportInventory(scope.row)
            }
          }
        }, [_vm._v("Report")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), (_vm.role == 3) ? _c('el-tab-pane', {
    attrs: {
      "label": "Zero Storage",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "ProduceName or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getZeroInventory.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.zeroName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "zeroName", $$v)
      },
      expression: "filters.zeroName"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getZeroInventory
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.zeroInventory,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productNo) + "\n\t\t\t\t\t\t")]
      }
    }], null, false, 1750233183)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "ProductName"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productName) + " " + _vm._s(scope.row.createDate ? "(" + scope.row.createDate + ")" : "") + "\n\t\t\t\t\t\t\t"), _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.upc))])]
      }
    }], null, false, 1926563046)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "left",
      "label": "Left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.zeroInventroyTotal
    },
    on: {
      "current-change": _vm.handleZeroChange
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.role == 3) ? _c('el-tab-pane', {
    attrs: {
      "label": "Products",
      "name": "third"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "ProduceName or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getDoctorProductList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.doctorProductName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "doctorProductName", $$v)
      },
      expression: "filters.doctorProductName"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getDoctorProductList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addFormVisible = true
      }
    }
  }, [_vm._v("Add Product")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.doctorProductList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productNo) + "\n\t\t\t\t\t\t")]
      }
    }], null, false, 1750233183)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "ProductName"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productName) + " " + _vm._s(scope.row.createDate ? "(" + scope.row.createDate + ")" : "") + "\n\t\t\t\t\t\t\t"), _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.upc))])]
      }
    }], null, false, 1926563046)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "size",
      "label": "Category"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditProduct(scope.row)
            }
          }
        }, [_vm._v("Edit Product")])]
      }
    }], null, false, 2749166596)
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleProductChange
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.role == 3) ? _c('el-tab-pane', {
    attrs: {
      "label": "Product Pool",
      "name": "fourth"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": "ProduceName or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getProductTemplateList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.productTemplateCondition),
      callback: function($$v) {
        _vm.$set(_vm.filters, "productTemplateCondition", $$v)
      },
      expression: "filters.productTemplateCondition"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getProductTemplateList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.productTemplateAddFormVisible = true
      }
    }
  }, [_vm._v("Add Product")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.productTemplateList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productNo) + "\n\t\t\t\t\t\t")]
      }
    }], null, false, 1750233183)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "ProductName"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.productName) + " " + _vm._s(scope.row.createDate ? "(" + scope.row.createDate + ")" : "") + "\n\t\t\t\t\t\t\t"), _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.upc))])]
      }
    }], null, false, 1926563046)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "size",
      "label": "Category"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageFreeDuration",
      "label": "Storage Free Duration (Month)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.storageFreeDuration != null ? scope.row.storageFreeDuration : "Not Set") + "\n\t\t\t\t\t\t")]
      }
    }], null, false, 2879858912)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0) ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("Not Distribute")]) : (scope.row.status == 1) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Distributed")]) : _vm._e()]
      }
    }], null, false, 1894842330)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditProductTemplate(scope.row)
            }
          }
        }, [_vm._v("Edit Product Template")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.showDistributeSelectDoctorWin(scope.row)
            }
          }
        }, [_vm._v("Distribute")])]
      }
    }], null, false, 1468722737)
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.productTemplateTotal
    },
    on: {
      "current-change": _vm.handleProductTemplateChange
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Report Missing Items",
      "width": "80%",
      "visible": _vm.reportFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.reportFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "report",
    attrs: {
      "model": _vm.report,
      "label-width": "220px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Product Name",
      "prop": "Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.report.product),
      callback: function($$v) {
        _vm.$set(_vm.report, "product", $$v)
      },
      expression: "report.product"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Missing Item",
      "prop": "id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.changeItem()
      }
    },
    model: {
      value: (_vm.report.id),
      callback: function($$v) {
        _vm.$set(_vm.report, "id", $$v)
      },
      expression: "report.id"
    }
  }, _vm._l((_vm.report.items), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.id,
        "label": item.displayName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Quantity",
      "prop": "quantity"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.report.quantity),
      callback: function($$v) {
        _vm.$set(_vm.report, "quantity", $$v)
      },
      expression: "report.quantity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.report.note),
      callback: function($$v) {
        _vm.$set(_vm.report, "note", $$v)
      },
      expression: "report.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.reportFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleReportInventory.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Product",
      "width": "80%",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addProduct",
    attrs: {
      "model": _vm.addProduct,
      "label-width": "220px",
      "rules": _vm.productFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "product"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.product),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "product", $$v)
      },
      expression: "addProduct.product"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Category",
      "prop": "size"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.size),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "size", $$v)
      },
      expression: "addProduct.size"
    }
  }, _vm._l((_vm.sizeList), function(size, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": size,
        "label": size
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Free Duration (Month)",
      "prop": "storageFreeDuration"
    }
  }, [_c('el-input-number', {
    model: {
      value: (_vm.addProduct.storageFreeDuration),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "storageFreeDuration", $$v)
      },
      expression: "addProduct.storageFreeDuration"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Condition",
      "prop": "condition"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.condition),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "condition", $$v)
      },
      expression: "addProduct.condition"
    }
  }, _vm._l((_vm.conditions), function(condition, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": condition,
        "label": condition
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "ASIN",
      "prop": "asin"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProduct.asin),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "asin", $$v)
      },
      expression: "addProduct.asin"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC",
      "prop": "upc"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProduct.upc),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "upc", $$v)
      },
      expression: "addProduct.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Weight",
      "prop": "weight"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProduct.weight),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "weight", $$v)
      },
      expression: "addProduct.weight"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProduct.note),
      callback: function($$v) {
        _vm.$set(_vm.addProduct, "note", $$v)
      },
      expression: "addProduct.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddProduct.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Product",
      "width": "80%",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editProduct",
    attrs: {
      "model": _vm.editProduct,
      "label-width": "220px",
      "rules": _vm.productFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProduct.productName),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "productName", $$v)
      },
      expression: "editProduct.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Free Duration (Month)",
      "prop": "storageFreeDuration"
    }
  }, [_c('el-input-number', {
    model: {
      value: (_vm.editProduct.storageFreeDuration),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "storageFreeDuration", $$v)
      },
      expression: "editProduct.storageFreeDuration"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Category",
      "prop": "size"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProduct.size),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "size", $$v)
      },
      expression: "editProduct.size"
    }
  }, _vm._l((_vm.sizeList), function(size, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": size,
        "label": size
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Condition",
      "prop": "condition"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProduct.condition),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "condition", $$v)
      },
      expression: "editProduct.condition"
    }
  }, _vm._l((_vm.conditions), function(condition, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": condition,
        "label": condition
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "ASIN"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editProduct.asin),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "asin", $$v)
      },
      expression: "editProduct.asin"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editProduct.upc),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "upc", $$v)
      },
      expression: "editProduct.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Weight"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editProduct.weight),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "weight", $$v)
      },
      expression: "editProduct.weight"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProduct.note),
      callback: function($$v) {
        _vm.$set(_vm.editProduct, "note", $$v)
      },
      expression: "editProduct.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Product Template",
      "width": "80%",
      "visible": _vm.productTemplateAddFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.productTemplateAddFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addProductTemplate",
    attrs: {
      "model": _vm.addProductTemplate,
      "label-width": "220px",
      "rules": _vm.productFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "product"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProductTemplate.product),
      callback: function($$v) {
        _vm.$set(_vm.addProductTemplate, "product", $$v)
      },
      expression: "addProductTemplate.product"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Category",
      "prop": "size"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProductTemplate.size),
      callback: function($$v) {
        _vm.$set(_vm.addProductTemplate, "size", $$v)
      },
      expression: "addProductTemplate.size"
    }
  }, _vm._l((_vm.sizeList), function(size, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": size,
        "label": size
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Free Duration (Month)",
      "prop": "storageFreeDuration"
    }
  }, [_c('el-input-number', {
    model: {
      value: (_vm.addProductTemplate.storageFreeDuration),
      callback: function($$v) {
        _vm.$set(_vm.addProductTemplate, "storageFreeDuration", $$v)
      },
      expression: "addProductTemplate.storageFreeDuration"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Condition",
      "prop": "condition"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProductTemplate.condition),
      callback: function($$v) {
        _vm.$set(_vm.addProductTemplate, "condition", $$v)
      },
      expression: "addProductTemplate.condition"
    }
  }, _vm._l((_vm.conditions), function(condition, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": condition,
        "label": condition
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "ASIN",
      "prop": "asin"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProductTemplate.asin),
      callback: function($$v) {
        _vm.$set(_vm.addProductTemplate, "asin", $$v)
      },
      expression: "addProductTemplate.asin"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC",
      "prop": "upc"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProductTemplate.upc),
      callback: function($$v) {
        _vm.$set(_vm.addProductTemplate, "upc", $$v)
      },
      expression: "addProductTemplate.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Weight",
      "prop": "weight"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addProductTemplate.weight),
      callback: function($$v) {
        _vm.$set(_vm.addProductTemplate, "weight", $$v)
      },
      expression: "addProductTemplate.weight"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addProductTemplate.note),
      callback: function($$v) {
        _vm.$set(_vm.addProductTemplate, "note", $$v)
      },
      expression: "addProductTemplate.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.productTemplateAddFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddProductTemplate.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Product Template",
      "width": "80%",
      "visible": _vm.productTemplateEditFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.productTemplateEditFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editProductTemplate",
    attrs: {
      "model": _vm.editProductTemplate,
      "label-width": "220px",
      "rules": _vm.productFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProductTemplate.productName),
      callback: function($$v) {
        _vm.$set(_vm.editProductTemplate, "productName", $$v)
      },
      expression: "editProductTemplate.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Free Duration (Month)",
      "prop": "storageFreeDuration"
    }
  }, [_c('el-input-number', {
    model: {
      value: (_vm.editProductTemplate.storageFreeDuration),
      callback: function($$v) {
        _vm.$set(_vm.editProductTemplate, "storageFreeDuration", $$v)
      },
      expression: "editProductTemplate.storageFreeDuration"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Category",
      "prop": "size"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProductTemplate.size),
      callback: function($$v) {
        _vm.$set(_vm.editProductTemplate, "size", $$v)
      },
      expression: "editProductTemplate.size"
    }
  }, _vm._l((_vm.sizeList), function(size, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": size,
        "label": size
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Condition",
      "prop": "condition"
    }
  }, [_c('el-select', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProductTemplate.condition),
      callback: function($$v) {
        _vm.$set(_vm.editProductTemplate, "condition", $$v)
      },
      expression: "editProductTemplate.condition"
    }
  }, _vm._l((_vm.conditions), function(condition, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": condition,
        "label": condition
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "ASIN"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editProductTemplate.asin),
      callback: function($$v) {
        _vm.$set(_vm.editProductTemplate, "asin", $$v)
      },
      expression: "editProductTemplate.asin"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.editProductTemplate.status == 1 ? true : false
    },
    model: {
      value: (_vm.editProductTemplate.upc),
      callback: function($$v) {
        _vm.$set(_vm.editProductTemplate, "upc", $$v)
      },
      expression: "editProductTemplate.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Weight"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editProductTemplate.weight),
      callback: function($$v) {
        _vm.$set(_vm.editProductTemplate, "weight", $$v)
      },
      expression: "editProductTemplate.weight"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editProductTemplate.note),
      callback: function($$v) {
        _vm.$set(_vm.editProductTemplate, "note", $$v)
      },
      expression: "editProductTemplate.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.productTemplateEditFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmitTemplate.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Select which users to send under",
      "width": "80%",
      "visible": _vm.selectDoctorsVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.selectDoctorsVisible = $event
      }
    }
  }, [_c('div', _vm._l((_vm.selectedDoctorNames), function(userName, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "effect": "dark"
      }
    }, [_vm._v(_vm._s(userName))])
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "350px"
    },
    attrs: {
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: (_vm.distributeSelectedDoctors),
      callback: function($$v) {
        _vm.distributeSelectedDoctors = $$v
      },
      expression: "distributeSelectedDoctors"
    }
  }, _vm._l((_vm.doctorList), function(user, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": user.userName,
        "value": user.userNo
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.selectDoctorsVisible = false;
        _vm.distributeSelectedDoctors = [];
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.distributeProductTempate.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fff121c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nurse/inventory.vue
// module id = 854
// module chunks = 1